import { Size } from '@ps/web-core-enums';
import { Translation, useScreenSize } from '@ps/web-shared-components';
import classNames from 'clsx';
import React, { useMemo } from 'react';

import type { CasinoGame } from '@swf/core/types/CasinoGame';
import { getTablePropsFromGame } from '@swf/core/utils/casino';
import getBackgroundImageStyle from '@swf/core/utils/getBackgroundImageStyle';

import CasinoGameIcon from '../CasinoGameIcon/CasinoGameIcon';

import { TXTCLI_Description } from './CasinoGameInfoCard.messages.json';
import styles from './CasinoGameInfoCard.scss';
import GameFeatures from './components/GameFeatures/GameFeatures';
import featureStyles from './components/GameFeatures/GameFeatures.scss';

interface Props {
  isModal?: boolean;
  fsbLaunch?: boolean;
  raceId?: string;
  game: CasinoGame;
}

const CasinoGameInfoCard: React.FC<Props> = (props) => {
  const { isModal, game, fsbLaunch, raceId } = props;
  const displayType = isModal ? styles.modal : styles.page;

  const { greaterThan } = useScreenSize();

  const isLarge = greaterThan(Size.XSmall);

  const table = useMemo(() => getTablePropsFromGame(game), [game]);

  return (
    <div className={styles.areaContainer}>
      <div className={classNames(styles.container, displayType)}>
        <div className={classNames(styles.gamePage, displayType)}>
          <div className={classNames(styles.imageContainer, displayType)}>
            <CasinoGameIcon game={game} disabled scale={false} />
          </div>
          <div className={classNames(styles.featuresContainer, displayType)}>
            {table ? (
              <GameFeatures
                className={classNames(!isLarge && featureStyles.noFeatureBlock)}
                data={table}
                game={game}
                fsbLaunch={fsbLaunch}
                raceId={raceId}
              />
            ) : null}
          </div>
        </div>
        {game.images && (
          <div
            className={styles.infoBackground}
            style={getBackgroundImageStyle(game.images.icnSquare)}
          />
        )}
      </div>
      {!isLarge && table && (
        <GameFeatures
          data={table}
          game={game}
          fsbLaunch={fsbLaunch}
          raceId={raceId}
          className={featureStyles.noTitle}
        />
      )}
      {game.desc && (
        <div className={classNames(styles.description, displayType)}>
          <h1 className={styles.gameDescriptionTitle}>
            <Translation {...TXTCLI_Description} />
          </h1>
          <p className={styles.gameDescription}>{game.desc}</p>
        </div>
      )}
    </div>
  );
};

export default CasinoGameInfoCard;
